import { render, staticRenderFns } from "./association.vue?vue&type=template&id=7c6567a8"
import script from "./association.vue?vue&type=script&lang=ts"
export * from "./association.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports